import { getCreateStorefrontDeluxeCheckoutUrl } from '../../storefront-checkout-urls';
import { buildStorefrontAuthorizeCheckoutRequest } from '../storefront-authorize/buildStorefrontAuthorizeCheckoutRequest';

export async function startStorefrontDeluxeCheckout(params) {
  const body = buildStorefrontAuthorizeCheckoutRequest(params);
  const url = getCreateStorefrontDeluxeCheckoutUrl();
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Deluxe checkout failed (${response.status})`);
  }
  return data;
}

export async function chargeStorefrontDeluxeCheckout({ companyId, appointmentId, paymentId, cryptogram }) {
  const { getChargeStorefrontDeluxeCheckoutUrl } = await import('../../storefront-checkout-urls/endpoints');
  const url = getChargeStorefrontDeluxeCheckoutUrl();
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId, appointmentId, paymentId, cryptogram }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.success) {
    throw new Error(data.error || data.message || `Deluxe payment failed (${response.status})`);
  }
  return data;
}
